<template>
    <v-dialog v-model="dialog" width="600" :fullscreen="isMobileOrTablet()" persistent>
        <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div class="w-75 text-truncate text-white">
                    <span class="font-weight-bold text-h6">{{ dialog_title }}</span>
                    <div class="text-caption">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row dense>
                        <v-col cols="12">
                            <v-autocomplete
                                v-model="faculty_load"
                                :rules="[formRules.required]"
                                label="Course Load"
                                variant="outlined"
                                rounded="lg"
                                color="darkGreen"
                                :items="facultyLoadData"
                                :item-title="getItemTitle"
                                item-value="id"
                                return-object
                                :readonly="action == 'edit'"
                                >
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12">
                            <v-date-input
                            v-model="date_submitted"
                            prepend-icon=""
                            prepend-inner-icon="mdi-calendar"
                            :rules="[formRules.required]"
                            variant="outlined"
                            rounded="lg"
                            type="text"
                            color="darkGreen"
                            label="Date Submitted"
                            ></v-date-input>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Cancel" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
                <v-btn class="mr-1" :loading="loading" text="Save" variant="elevated" elevation="1" color="darkGreen" @click="validateForm()"></v-btn>
            </v-card-actions>
        </v-card>

        <v-dialog v-model="confirmSave" width="450" persistent>
            <v-card color="secondary" rounded="lg" class="pa-2">
                <v-card-text>
                    <div class="font-weight-bold mt-2 text-h6">Are you sure you want to save this compliance submission ?</div>
                    <div class="font-weight-light mt-2">Note: Once confirmed, you cannot remove this submission and it will be counted, Please review the information carefully before proceeding.</div>
                </v-card-text>
                <template v-slot:actions>
                <v-spacer></v-spacer>

                <v-btn @click="confirmSave = false" :disabled="loading" variant="outlined">
                    Cancel
                </v-btn>
                <v-btn :loading="loading" @click="saveCompliance()" color="darkGreen" variant="elevated">
                    Confirm
                </v-btn>
                </template>
            </v-card>
        </v-dialog>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
     emits: ["refresh"],
     data(){
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,

            id: null,
            faculty_load: null,
            date_submitted: null,
           
            facultyLoadData: [],
            userData: [],
            complianceData: [],
            confirmSave: false
        }
     },
     methods: {
        initAdd(userData, complianceData){
            this.dialog = true
            this.dialog_title = 'Checked Compliance Submission'
            this.dialog_sub_title = 'Add new compliance submission'
            this.action = 'add'

            this.userData = userData
            this.complianceData = complianceData

            this.initFacultyLoad()
        },
        initUpdate(data){
            this.dialog = true
            this.dialog_title = 'Checked Compliance Submission'
            this.dialog_sub_title = 'Edit compliance submission'
            this.action = 'edit'

            this.id = data.id
            this.faculty_load = data.facultyLoad
            this.date_submitted = this.parseYMDToDate(data.date_submitted)
        },
        getItemTitle(item) {
            return `${item.code} - ${item.title} (${item.section_code})`;
        },
        async initFacultyLoad(){
            const token = localStorage.getItem('aums-token')
            await axios.get(process.env.VUE_APP_SERVER_URL + '/faculty-load/findAllLoadWithoutFileUpload/' + this.userData.id + '/' + this.$store.state.semester_schoolyear.id + '/' + this.complianceData.id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.loading = false
                    this.facultyLoadData = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false
                    showSnackbar('Token expired! Logging out..')

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        async validateForm(){
            
            const { valid } = await this.$refs.form.validate()

            if(valid){
                if(this.action == 'add'){
                    this.confirmSave = true
                }
                else if(this.action == 'edit'){
                    this.saveCompliance()
                }
            }
        },
        saveCompliance(){
            const { showSnackbar } = useSnackbar()
            this.loading = true
            let formData = {
                id: this.id,
                user_id: this.userData.id,
                compliance_id: this.complianceData.id,
                faculty_load: this.faculty_load.id,
                date_submitted: this.formatDateToYMD(this.date_submitted),
                semester_schoolyear_id: this.$store.state.semester_schoolyear.id
            }

            const token = localStorage.getItem('aums-token')

            if(this.action == 'add'){
                axios.post(process.env.VUE_APP_SERVER_URL + '/compliance-upload-details', formData,
                { headers:
                    { 
                        'Authorization': `Bearer ${token}`,
                    }
                }
                ).then((res)=>{
                    if(res.data.status == 200){
                        this.loading = false
                        this.$emit('refresh')
                        this.confirmSave = false
                        showSnackbar('Compliance Checked and Submitted successfully added!')
                        this.$refs.form.reset()
                        this.dialog = false
                    }
                }).catch((error)=>{
                    if(error.response.status == 401){
                        this.loading = false
                        showSnackbar('Token expired! Logging out..')

                        localStorage.removeItem("vuex");
                        localStorage.removeItem("aums-token");
                        window.location.reload();
                    }
                    else{
                        console.log(error)
                    }
                })
            }
            else if(this.action == 'edit'){
                axios.patch(process.env.VUE_APP_SERVER_URL + '/compliance-upload-details/' + this.id, formData,
                { headers:
                    { 
                        'Authorization': `Bearer ${token}`,
                    }
                }
                ).then((res)=>{
                    if(res.data.status == 200){
                        this.loading = false
                        this.$emit('refresh')
                        this.confirmSave = false
                        showSnackbar('Compliance Submission successfully updated!')
                        this.$refs.form.reset()
                        this.dialog = false
                    }
                }).catch((error)=>{
                    if(error.response.status == 401){
                        this.loading = false
                        showSnackbar('Token expired! Logging out..')

                        localStorage.removeItem("vuex");
                        localStorage.removeItem("aums-token");
                        window.location.reload();
                    }
                    else{
                        console.log(error)
                    }
                })
            }
        },
        parseYMDToDate(ymdString) {
            return new Date(ymdString);
        },
        formatDateToYMD(dateInput) {
            const date = new Date(dateInput);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        closeDialog(){
            this.$refs.form.reset()
            this.$emit('refresh')
            this.dialog = false
        }
     }
})
</script>

<style scoped>

</style>